import * as v from "valibot";

export default function useSchemas() {
    const { t } = useI18n();

    const BomNameSchema = v.pipe(v.string(), v.trim(), v.nonEmpty(t("BOMTool.BOMNameRequired")));

    const BomQuantitySchema = v.pipe(
        v.string(),
        v.decimal("A number is required"),
        v.transform(Number),
        v.transform(Math.floor),
        v.minValue(1, "Value must be 1 or more")
    );

    const EmailSchema = v.pipe(v.string(), v.trim(), v.email(t("Global.EmailRequired")));

    const LoginSchema = v.object({
        UserName: v.pipe(v.string(), v.trim(), v.nonEmpty(t("SignIn.UserNameRequiredErrorMessage"))),
        Password: v.pipe(v.string(), v.trim(), v.nonEmpty(t("Global.PasswordRequired"))),
    });

    const RegisterSchema = v.pipe(
        v.object({
            UserName: v.pipe(
                v.string(),
                v.trim(),
                v.nonEmpty(t("Register.UserNameError")),
                v.minLength(6, t("Register.UsernameMinLength")),
                v.regex(/^[a-zA-Z0-9_.-]+$/, t("Register.ValidUsernameError"))
            ),
            Name: v.pipe(v.string(), v.trim(), v.nonEmpty(t("Register.NameError"))),
            CompanyName: v.optional(v.pipe(v.string(), v.trim())),
            Email: v.pipe(
                v.string(),
                v.trim(),
                v.nonEmpty(t("Register.EmailError")),
                v.email(t("Register.ValidEmailError"))
            ),
            Password: v.pipe(
                v.string(),
                v.nonEmpty(t("Global.PasswordRequired")),
                v.minLength(8, t("Register.PasswordStrengthCharactersError"))
            ),
            ConfirmPassword: v.pipe(v.string(), v.nonEmpty(t("Register.ConfirmPasswordError"))),
            TermsAndConditions: v.literal(true, t("Register.TermsConditionsError")),
        }),
        v.forward(
            v.partialCheck(
                [["Password"], ["ConfirmPassword"]],
                (input) => input.Password === input.ConfirmPassword,
                t("Register.PasswordMatchError")
            ),
            ["ConfirmPassword"]
        )
    );

    const ForgotPasswordSchema = v.object({
        Email: v.pipe(
            v.string(),
            v.trim(),
            v.nonEmpty(t("Register.EmailError")),
            v.email(t("Register.ValidEmailError"))
        ),
    });

    const ResetPasswordSchema = v.pipe(
        v.object({
            NewPassword: v.pipe(
                v.string(),
                v.nonEmpty(t("Global.PasswordRequired")),
                v.minLength(8, t("Register.PasswordStrengthCharactersError"))
            ),
            ConfirmPassword: v.pipe(v.string(), v.nonEmpty(t("Register.ConfirmPasswordError"))),
        }),
        v.forward(
            v.partialCheck(
                [["NewPassword"], ["ConfirmPassword"]],
                (input) => input.NewPassword === input.ConfirmPassword,
                t("Register.PasswordMatchError")
            ),
            ["ConfirmPassword"]
        )
    );

    return {
        BomNameSchema,
        BomQuantitySchema,
        EmailSchema,
        LoginSchema,
        RegisterSchema,
        ForgotPasswordSchema,
        ResetPasswordSchema,
    };
}
